import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  className?: string;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'medium',
  loading = false,
  className = '', 
  children,
  disabled,
  ...props 
}) => {
  const sizeClasses = {
    small: 'px-4 py-2 text-sm',
    medium: 'px-6 py-3 text-base',
    large: 'px-8 py-4 text-lg'
  };

  const getVariantStyles = () => {
    if (variant === 'secondary') {
      return {
        backgroundColor: 'transparent',
        color: 'var(--text-primary)',
        borderColor: 'var(--border-color)'
      };
    }
    if (variant === 'danger') {
      return {
        backgroundColor: '#ef4444',
        color: '#ffffff',
        borderColor: '#ef4444'
      };
    }
    // primary
    return {
      backgroundColor: 'var(--accent-color)',
      color: '#ffffff',
      borderColor: 'var(--accent-color)'
    };
  };

  return (
    <button 
      className={`${sizeClasses[size]} rounded-lg border font-medium transition-all focus:outline-none focus:ring-2 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 ${className}`}
      style={{
        ...getVariantStyles(),
        '--tw-ring-color': 'var(--accent-color)'
      } as React.CSSProperties}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </button>
  );
};
